<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'invoice-shipper',
};
</script>

<style>
</style>
